// reducer.js
import {
  GET_CAMPAIGN_NOTES,
  GET_CAMPAIGN_NOTES_SUCCESS,
  GET_CAMPAIGN_NOTES_ERROR,
  CREATE_CAMPAIGN_NOTES,
  CREATE_CAMPAIGN_NOTES_SUCCESS,
  CREATE_CAMPAIGN_NOTES_ERROR,
  UPDATE_CAMPAIGN_NOTES,
  UPDATE_CAMPAIGN_NOTES_SUCCESS,
  UPDATE_CAMPAIGN_NOTES_ERROR,
  DELETE_CAMPAIGN_NOTES,
  DELETE_CAMPAIGN_NOTES_SUCCESS,
  DELETE_CAMPAIGN_NOTES_ERROR,
} from "./actionTypes";

const initialState = {
  campaign_notes_loading: false,
  campaign_notes_error: null,
  campaign_notes: [],
};

const campaignNotesReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_CAMPAIGN_NOTES:
    case CREATE_CAMPAIGN_NOTES:
    case UPDATE_CAMPAIGN_NOTES:
    case DELETE_CAMPAIGN_NOTES:
      return {
        ...state,
        campaign_notes_loading: true,
        campaign_notes_error: null,
      };

    case GET_CAMPAIGN_NOTES_SUCCESS:
      return {
        ...state,
        campaign_notes_loading: false,
        campaign_notes: action.payload,
      };
    case CREATE_CAMPAIGN_NOTES_SUCCESS:
      return {
        ...state,
        campaign_notes_loading: false,
        campaign_notes: [...state.campaign_notes, action.payload],
      };
    case UPDATE_CAMPAIGN_NOTES_SUCCESS:
      return {
        ...state,
        campaign_notes_loading: false,
        campaign_notes: state.campaign_notes.map((campaign_note) => {
        if (campaign_note.id === action.payload.id) {
          return action.payload
        }
        return campaign_note
      }),
    }
    case DELETE_CAMPAIGN_NOTES_SUCCESS:
      return {
        ...state,
        campaign_notes_loading: false,
        campaign_notes: state.campaign_notes.filter(
          (campaign_note) => campaign_note.id !== action.payload.id
        )
      };

    case GET_CAMPAIGN_NOTES_ERROR:
    case CREATE_CAMPAIGN_NOTES_ERROR:
    case UPDATE_CAMPAIGN_NOTES_ERROR:
    case DELETE_CAMPAIGN_NOTES_ERROR:
      return {
        ...state,
        campaign_notes_loading: false,
        campaign_notes_error: action.payload,
      };

    default:
      return state;
  }
};

export default campaignNotesReducer;
